import { StyleSheet, View } from "@react-pdf/renderer";

export const tableStyles = StyleSheet.create({
    table: {
        width: "100%",
        marginBottom: 20,
        flexDirection: "row",
        justifyContent: "space-between",
        borderTopWidth: 0.8,
        borderLeftWidth: 0.8,
        borderTopColor: "#d8d8d8",
        borderLeftColor: "#d8d8d8"
    },
    pageTitle: {
        color: "black",
        fontFamily: "Poppins-Medium",
        fontSize: 14,
        marginBottom: 10
    },
    tableHeader: {
        backgroundColor: "#f0f0f0",
        width: "100%",
        height: 19
    },
    tableHeaderText: {
        fontFamily: "Poppins-Medium",
        fontSize: 7,
        textAlign: "center",
        flexWrap: "nowrap",
        overflow: "hidden",
    },
    tableCell: {
        paddingVertical: 0,
        paddingHorizontal: 2,
        textAlign: "center",
        flexGrow: 1,
        fontSize: 9,
        borderBottomWidth: 0.8,
        borderRightWidth: 0.8,
        borderBottomColor: "#d8d8d8",
        borderRightColor: "#d8d8d8",
    },
    tableCellHeight: {
        height: 19,
        justifyContent: "center",
        alignItems: "flex-start"
    },
    link: {
        textDecoration: "underline",
    },
    note: {
        marginTop: 10,
        fontSize: 8,
        lineHeight: 1.1,
        backgroundColor: "#f0f0f0",
        padding: 8
    }
});

export const normalizePDFColumnWeight = (weight: unknown): number => {
    const parsed = Number(weight);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
};

export const hasConfiguredPDFColumnWeights = (columnWeights: unknown[]): boolean => (
    columnWeights.some((weight) => {
        const parsed = Number(weight);
        return Number.isFinite(parsed) && parsed > 0;
    })
);

interface PDFTableProps {
    columns: React.ReactNode[];
    columnWeights?: unknown[];
}

export function PDFTable({ columns, columnWeights = [] }: PDFTableProps) {
    const useConfiguredWeights = hasConfiguredPDFColumnWeights(columnWeights);
    return (
        <View style={tableStyles.table}>
            {columns.map((i, index) => (
                <View
                    style={useConfiguredWeights
                        ? {
                            flexBasis: 0,
                            flexGrow: normalizePDFColumnWeight(columnWeights[index]),
                        }
                        : { flexGrow: 1 }}
                    key={index}
                >
                    {i}
                </View>
            ))}
        </View>
    );
}
